import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

const tabData = [
   {
      id: '01ete',
      title: '01. Tailor-Made eCommerce Platform Development',
      intitle: 'Tailor-Made eCommerce Platform Development',
      icon: '/assets/svg/industries/Ecommerce/01.svg',
      content:
         'We create and customize eCommerce platforms specific to your business model for a smooth shopping experience, scalability, and optimal performance for sustainable growth. Our offerings are customized product catalogs, enhanced search and filtering capabilities, and user-friendly navigation to increase user interaction. We interface with ERP, CRM, and third-party APIs to automate functions and inventory processes. With responsive design, multiple language support, and strong security capabilities, we provide scalable platforms that yield more conversions and loyalty.',
   },
   {
      id: '02ete',
      title: '02. Full-Stack Development & CRM Solutions',
      intitle: 'Full-Stack Development & CRM Solutions',
      icon: '/assets/svg/industries/Ecommerce/02.svg',
      content:
         'Our team builds powerful backend systems, engaging frontends, and integrated CRM solutions to enhance customer interactions and streamline eCommerce operations. We create RESTful APIs, microservices, and cloud-native designs for smooth functioning. Our frontends have responsive UI/UX with easy-to-use navigation, while the backend provides secure management of data and quick processing. The CRM integration provides customer profiling, automated marketing, and real-time analytics for enhanced customer relationship management and increased retention.',
   },
   {
      id: '03ete',
      title: '03. Secure Online Payment Integration',
      intitle: 'Secure Online Payment Integration',
      icon: '/assets/svg/industries/Ecommerce/03.svg',
      content:
         'We set up systems that let your customers pay in different currencies using cards, bank transfers, or digital wallets like PayPal, Stripe, and Apple Pay. We also build in security using tokenization, encryption, and two factor authentication so their data stays safe and your business stays PCI compliant. On top of that, we handle things like recurring payments, tax calculations, and real time tracking so everything runs smoothly and you spend less time dealing with payment issues.',
   },
   {
      id: '04ete',
      title: '04. High-Performance Progressive Web Apps (PWAs)',
      intitle: 'High-Performance Progressive Web Apps (PWAs)',
      icon: '/assets/svg/industries/Ecommerce/04.svg',
      content:
         'We create rapid, interactive, and mobile-compatible PWAs that deliver an app-like shopping experience on web browsers, enhancing accessibility and user retention. Our PWAs are equipped with offline capabilities, push messages, and instant loading speeds, which improve the user experience. We employ service workers and caching tactics to deliver seamless performance, even in low-bandwidth networks. With cross-platform support and SEO optimization, our PWAs enhance visibility and drive stronger engagement and conversions.',
   },
   {
      id: '05ete',
      title: '05. Multi-Seller Marketplace Development',
      intitle: 'Multi-Seller Marketplace Development',
      icon: '/assets/svg/industries/Ecommerce/05.svg',
      content:
         'Our multi-seller marketplace solutions allow companies to develop platforms such as Amazon, Etsy, or Flipkart with vendor management, auto payments, and live analytics. We build straightforward vendor dashboards with product listing, inventory management, and order management features. Our solutions come with commission-based revenue streams, auto payout mechanisms, and shipping integrations. With advanced search filters, personal recommendations, and review mechanisms, we make the shopping experience better for buyers and sellers alike.',
   },
   {
      id: '06ete',
      title: '06. Unified eCommerce Aggregator Portals',
      intitle: 'Unified eCommerce Aggregator Portals',
      icon: '/assets/svg/industries/Ecommerce/06.svg',
      content:
         'We build aggregator eCommerce platforms that bring multiple vendors together, allowing customers to compare and purchase products from a single digital hub. Our platforms feature real-time product consolidation, price comparison, and inventory synchronization. We use AI-based recommendation engines and dynamic pricing algorithms to provide customized shopping experiences. With centralized order management, automated billing, and multi-vendor reporting, we facilitate streamlined marketplace operations and enhanced customer satisfaction.',
   },
];

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-3">
               End-to-end eCommerce Software Development Solutions
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               As a reliable eCommerce software development firm, we develop high-performance, scalable, and feature-rich digital commerce solutions that maximize user experiences and conversions. From user-friendly storefronts to powerful backend architecture, we provide solutions that deliver online success. Explore our comprehensive eCommerce software services:
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
